// components/SpinnerToast.tsx
import React from 'react';
import { ToastContainer, toast, Id } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './spinnerToaster.css';

let toastId: Id | null = null;

type Props = {
  message?: string;
};

export const ToastSpinner = ({ message = 'Processing...' }: Props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
      <div className="custom-spinner" />
      <span>{message}</span>
    </div>
  );
};

export const showSpinnerToast = (message = 'Processing...') => {
  if (!toast.isActive(toastId as Id)) {
    toastId = toast.loading(<ToastSpinner message={message} />, {
      position: 'bottom-right',
      closeOnClick: false,
      closeButton: false,
      autoClose: false,
      draggable: false,
    });
  }
};

export const hideSpinnerToast = () => {
  if (toastId) {
    toast.dismiss(toastId);
    toastId = null;
  }
};

export const SpinnerToastContainer = () => <ToastContainer />;
